function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "analysis");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-sample-analysis",
  transform: "translate(-4.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M20.632178,17.49 L15.520809,8.73 L15.520809,4 L16.5210769,4 C17.0735096,4 17.5213448,3.55228475 17.5213448,3 C17.5213448,2.44771525 17.0735096,2 16.5210769,2 L8.51893379,2 C7.96650109,2 7.5186659,2.44771525 7.5186659,3 C7.5186659,3.55228475 7.96650109,4 8.51893379,4 L9.51920168,4 L9.51920168,8.73 L4.40783275,17.49 C3.8673818,18.4175644 3.86385258,19.5631301 4.39857812,20.4940051 C4.93330366,21.4248801 5.92478389,21.9991854 6.99852659,22 L18.0014734,22 C19.0752161,21.9991854 20.0666963,21.4248801 20.6014219,20.4940051 C21.1361474,19.5631301 21.1326182,18.4175644 20.5921672,17.49 L20.632178,17.49 Z M11.3797,9.49 C11.4679235,9.34149787 11.5161693,9.17268289 11.5197375,9 L11.5197375,4 L13.5202732,4 L13.5202732,9 C13.5221025,9.17608621 13.5704101,9.34856719 13.6603108,9.5 L14.5205411,11 L10.5194696,11 L11.3797,9.49 Z M18.9017145,19.49 C18.7241146,19.7975445 18.3966903,19.9878565 18.0414841,19.99 L7.03853731,19.99 C6.68333112,19.9878565 6.35590678,19.7975445 6.17830692,19.49 C5.99962627,19.1805989 5.99962627,18.7994011 6.17830692,18.49 L9.34915614,13 L15.7008573,13 L18.9017145,18.5 C19.0803952,18.8094011 19.0803952,19.1905989 18.9017145,19.5 L18.9017145,19.49 Z M10.5194696,15 C9.96703687,15 9.51920168,15.4477153 9.51920168,16 C9.51920168,16.5522847 9.96703687,17 10.5194696,17 C11.0719023,17 11.5197375,16.5522847 11.5197375,16 C11.5197375,15.4477153 11.0719023,15 10.5194696,15 Z M14.5205411,16 C13.9681084,16 13.5202732,16.4477153 13.5202732,17 C13.5202732,17.5522847 13.9681084,18 14.5205411,18 C15.0729738,18 15.520809,17.5522847 15.520809,17 C15.520809,16.4477153 15.0729738,16 14.5205411,16 Z",
  id: "analysis"
})));

var SvgAnalysis = function SvgAnalysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnalysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analysis.b9b823f0.svg";
export { ForwardRef as ReactComponent };